import { forwardRef as reactForwardRef } from "react";
import { Button, ButtonProps } from "@chakra-ui/react";
import { primary, secondary, tertiary } from "theme/button";

export function PrimaryButton({ children, ...rest }: ButtonProps) {
  return (
    <Button variant="solid" sx={primary} {...rest}>
      {children}
    </Button>
  );
}

export const PrimaryButtonWithRef = reactForwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button ref={ref} variant="solid" sx={primary} {...props} />
));

PrimaryButtonWithRef.displayName = "PrimaryButtonWithRef";

export function SecondaryButton({ children, ...rest }: ButtonProps) {
  return (
    <Button variant="outline" sx={secondary} {...rest}>
      {children}
    </Button>
  );
}

export const SecondaryButtonWithRef = reactForwardRef<HTMLButtonElement, ButtonProps>(({ children, ...props }, ref) => (
  <Button ref={ref} variant="outline" sx={secondary} {...props}>
    {children}
  </Button>
));

SecondaryButtonWithRef.displayName = "SecondaryButtonWithRef";

export function TertiaryButton({ children, ...rest }: ButtonProps) {
  return (
    <Button variant="solid" sx={tertiary} {...rest}>
      {children}
    </Button>
  );
}

export const TertiaryButtonWithRef = reactForwardRef<HTMLButtonElement, ButtonProps>(({ children, ...props }, ref) => (
  <Button ref={ref} variant="solid" sx={tertiary} {...props}>
    {children}
  </Button>
));

TertiaryButtonWithRef.displayName = "TertiaryButtonWithRef";
